import { render, staticRenderFns } from "./GoalVisualSettingsModal.vue?vue&type=template&id=1b07d488&"
import script from "./GoalVisualSettingsModal.vue?vue&type=script&lang=js&"
export * from "./GoalVisualSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports